import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NavbarService } from '../navbar.service';
import { StudentapiService } from '../studentapi.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  formlogin !: FormGroup
  pass: any;
  username: any;
  user_id: any;
  chngpwd: any;
  constructor(public formbuilder:FormBuilder,public router:Router, private api:StudentapiService,public nav:NavbarService) { }

  ngOnInit(): void {

    this.nav.show();
    this.formlogin = this.formbuilder.group({
     
      password:['', Validators.required],
      new_password: ['', Validators.required]
   
    });

    this.user_id = localStorage.getItem("user_id");
    this.pass = localStorage.getItem("password");

    // console.log(this.user_id);
    // console.log(this.pass);
    
  }

  submitlogin()
  {
      let user : {user_id:any,password:any,new_password:any} ={

          user_id :this.user_id,
          password: this.formlogin.controls.password.value,
          new_password: this.formlogin.controls.new_password.value,
      }
      // console.log(this.pass);
      // console.log(user.password);
      if(this.pass != user.password)
      {
        alert('please check current password');
      }
      else
      {
        // alert('i m in else');
        this.api.post('/StudentApi/changepassword',user).subscribe((res:any) =>{

          // console.log(res);

          let message = res['Msg'];
          if(res['status'] == 'success')
          {
             alert(message);
            this.logout();
          }
          else
          {
            alert(message);
          }
          

        });
      }

  }

  logout(){
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
